import moment from 'moment';
import constants from '$$helpers/constants';
import Filter from '../../controllers/filter';
import ProjectCalendar from '../../controllers/projectCalendar';

class Timeline {
  #instance = null;

  init(instance) {
    this.#instance = instance;
  }

  updateTimeScaleRange() {
    const range = this.#instance.getSubtaskDates();

    if (!range.start_date || !range.end_date) {
      return false;
    }
    const viewData = this.#instance.ganttDataApi.getActiveProjectData();
    const currentFilter = viewData && this.#instance.ganttDataApi.getCurrentFilter();
    const scaleUnit = this.#instance.config.durationData.mode;
    // const scaleAsideMultiplier = this.#instance.config.scale_unit === 'month' ? 5 : 1;
    const spaceBefore = ['hour', 'day'].includes(this.#instance.config.durationData.mode) ? -2 : -1;
    const colWidth = {
      hour: 20,
      day: 26,
      week: 70,
      month: 65,
      quarter: 135,
      year: 45,
    };
    const spaceAfter = Math.ceil(800 / colWidth[scaleUnit]);

    if (this.#instance.ganttDataApi.isExport()) {
      this.#instance.$container && this.#instance.$container.classList.add('gantt_layout_export');

      if (Object.keys(Filter.foundTasksMap).length > 1) {
        const tasks = _.map(Object.keys(Filter.foundTasksMap), id => this.#instance.getTask(id)).filter(task => task?.parent);

        range.start_date = new Date(Math.min(...tasks.map(task => task.start_date)));
        range.end_date = new Date(Math.max(...tasks.map(task => task.end_date)));
      }
    }

    const newStartDate = this.#instance.calculateEndDate(range.start_date, spaceBefore, scaleUnit);
    const newEndDate = this.#instance.calculateEndDate(range.end_date, spaceAfter, scaleUnit);
    const needRender = !(moment(newStartDate).isSame(this.#instance.config.start_date, 'hour') && moment(newEndDate).isSame(this.#instance.config.end_date, 'hour'));

    // if (newEndDate > this.#instance.config.end_date || newStartDate < this.#instance.config.start_date) {
    //   ProjectCalendar.addOrUpdateCalendar(this.#instance.config.gantt_id);
    // }

    if (currentFilter && currentFilter.properties.rangeDate?.start && currentFilter.properties.rangeDate?.end) {
      const rangeStart = moment(currentFilter.properties.rangeDate.start, constants.TASK_DATES_FORMAT).toDate();
      const rangeEnd = moment(currentFilter.properties.rangeDate.end, constants.TASK_DATES_FORMAT).toDate();

      this.#instance.config.start_date = rangeStart;
      this.#instance.config.end_date = rangeEnd;
      this.#instance.config.is_apply_timeline_range = true;
    } else if (needRender) {
      this.#instance.config.end_date = this.#instance.calculateEndDate(range.end_date, spaceAfter, scaleUnit);
      this.#instance.config.start_date = this.#instance.calculateEndDate(range.start_date, spaceBefore, scaleUnit);
      this.#instance.config.is_apply_timeline_range = false;
    }

    if (this.#instance.config.custom_start) {
      this.#instance.config.start_date = this.#instance.config.custom_start;
    }
    if (this.#instance.config.custom_end) {
      this.#instance.config.end_date = this.#instance.config.custom_end;
    }

    return needRender;
  }

  // hideShowAvatarAndTaskName(filterData) {
  //   const projectConfig = this.#instance.ganttDataApi.getActiveProjectConfig();
  //   const currentConfig = this.#instance.ganttDataApi.isExport() ? this.#instance.config : projectConfig;
  //
  //   if (filterData) {
  //     if (['insideText', 'rightSideText'].includes(currentConfig.right_side_text)) {
  //       this.#instance.config.right_side_text = 'insideText';
  //     } else {
  //       this.#instance.config.right_side_text = 'noTaskText';
  //     }
  //     this.#instance.config.show_resource_avatar = false;
  //   } else {
  //     if (currentConfig.right_side_text === true) {
  //       this.#instance.config.right_side_text = 'rightSideText';
  //     } else if (currentConfig.right_side_text === false || currentConfig.right_side_text === undefined) {
  //       this.#instance.config.right_side_text = 'insideText';
  //     } else {
  //       this.#instance.config.right_side_text = projectConfig.right_side_text;
  //     }
  //     this.#instance.config.show_resource_avatar = projectConfig.show_resource_avatar;
  //   }
  // }
}

export default new Timeline();
